import sortBy from 'lodash/sortBy';
import {createSelector} from '@reduxjs/toolkit';

export const getSeriesById = state => state.series.byId;
export const getSelectedSeriesId = state => state.series.selectedId;

export const getSeries = createSelector([getSeriesById], seriesById =>
  sortBy(Object.values(seriesById), 'name')
);

export const getSelectedSeries = createSelector(
  [getSeriesById, getSelectedSeriesId],
  (series, seriesId) => series[seriesId]
);

export const getSRSeries = createSelector([getSeries], series =>
  series.filter(s => s.supports.indexes)
);
